module.exports = __webpack_public_path__ + "img/banner.f0975dba.jpg";